import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconQrcode';
/** Renders an SVG icon. */
const SvgQrcode = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M10 21a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm17 5a1 1 0 1 1 0 2H14a1 1 0 1 1 0-2zM6 26h3v-3H6zm7-3v-2a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0m7-1a1 1 0 1 1 0 2h-1a1 1 0 1 1 0-2zm3-2a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm-4 0v-1h-1a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0M4 14a1 1 0 1 1 2 0v3h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm9 3v-7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-3v6a1 1 0 1 1-2 0m13 0v-2a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0m-16-4a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zm12 0a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zM10 4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm17 0a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm-4 5h3V6h-3zM6 9h3V6H6zm11-2V5a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0m-4-1V5a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0"
      />
    </svg>
  );
};
SvgQrcode.displayName = displayName;
export default SvgQrcode;
